/**
 * Displays the currently-selected variant title below the product
 * heading on the PDP. Shopify's richtext field doesn't accept the
 * variant title as a dynamic source, so we inject it client-side.
 *
 * - On load: reads the initial variant from the variant-picker's JSON
 *   script tag and inserts a <p> element after the product <h1>.
 * - On variant:update: refreshes the text.
 */
(function () {
  var SELECTED_CLASS = 'product-selected-variant';
  var EVENT = 'variant:update';

  function getContainer() {
    return document.querySelector(
      '[id^="ProductInformation-"] .product-details, .product-details'
    );
  }

  function getTitleHeading(container) {
    return container && container.querySelector('.product-details h1');
  }

  function ensureElement(container) {
    var heading = getTitleHeading(container);
    if (!heading) return null;

    var existing = container.querySelector('.' + SELECTED_CLASS);
    if (existing) return existing;

    var p = document.createElement('p');
    p.className = SELECTED_CLASS;
    heading.insertAdjacentElement('afterend', p);
    return p;
  }

  function readInitialVariant(container) {
    var jsonEl = container.querySelector('variant-picker script[type="application/json"]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent || '');
    } catch (err) {
      return null;
    }
  }

  function setText(el, variant) {
    if (!el || !variant) return;
    var title = variant.title || '';
    if (!title || title === 'Default Title') {
      el.remove();
      return;
    }
    el.textContent = title;
  }

  function init() {
    var container = getContainer();
    if (!container) return;

    var el = ensureElement(container);
    var variant = readInitialVariant(container);
    setText(el, variant);
  }

  function onVariantUpdate(event) {
    var detail = event && event.detail;
    if (!detail || !detail.resource) return;

    var container = getContainer();
    if (!container) return;

    var el = container.querySelector('.' + SELECTED_CLASS) || ensureElement(container);
    setText(el, detail.resource);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener(EVENT, onVariantUpdate);
})();
